"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.n = (module)=>{
        var getter = module && module.__esModule ? ()=>module['default'] : ()=>module;
        __webpack_require__.d(getter, {
            a: getter
        });
        return getter;
    };
})();
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    default: ()=>ErrorBoundary_ChatMessageErrorBoundary
});
const jsx_runtime_namespaceObject = require("react/jsx-runtime");
require("react");
const external_react_error_boundary_namespaceObject = require("react-error-boundary");
const external_TravelBotChatSingleDialogGeneric_js_namespaceObject = require("../../TravelBotChatSingleDialogGeneric.js");
const analytics_js_namespaceObject = require("../../analytics/analytics.js");
var analytics_js_default = /*#__PURE__*/ __webpack_require__.n(analytics_js_namespaceObject);
const defaultFallBackComponent = (displayedMessage)=>/*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_TravelBotChatSingleDialogGeneric_js_namespaceObject.TravelBotChatSingleDialogGeneric, {
        message: {
            role: 'assistant',
            content: displayedMessage
        }
    });
const ChatMessageErrorBoundary = ({ displayedMessage = '', children, FallbackComponent, compnentName })=>{
    const handleErrorLogging = function(error, info) {
        analytics_js_default().logError({
            compnentName,
            message: 'ChatMessageErrorBoundary',
            errorMessage: error?.message,
            ...info
        });
    };
    const Fallback = function() {
        return FallbackComponent ? FallbackComponent : defaultFallBackComponent(displayedMessage);
    };
    return /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_react_error_boundary_namespaceObject.ErrorBoundary, {
        FallbackComponent: Fallback,
        onError: handleErrorLogging,
        children: children
    });
};
const ErrorBoundary_ChatMessageErrorBoundary = ChatMessageErrorBoundary;
exports["default"] = __webpack_exports__["default"];
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "default"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
